import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * ArticleCard. Consumes only slug + image (+ minutes) from the metadata table
 * and pulls title/excerpt from the `articles` i18n namespace.
 */
export default function ArticleCard({ meta, testIdPrefix = 'article' }) {
  const { t } = useTranslation(['articles', 'insights', 'common']);
  const title = t(`${meta.slug}.title`, { ns: 'articles' });
  const excerpt = t(`${meta.slug}.excerpt`, { ns: 'articles' });

  return (
    <Link
      to={`/insights/${meta.slug}`}
      className="group flex flex-col gap-5 h-full transition-all duration-250"
      data-testid={`${testIdPrefix}-${meta.slug}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-brand-surface">
        <img
          src={meta.image}
          alt={title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]"
          style={{ filter: 'saturate(0.92) contrast(0.98)' }}
        />
      </div>
      <div className="flex flex-col flex-1">
        <p
          className="text-[11px] uppercase font-medium text-brand-accent mb-3"
          style={{ letterSpacing: '0.18em' }}
        >
          {t('cardMeta', { ns: 'insights' })} · {t('readingTime', { ns: 'common', min: meta.minutes })}
        </p>
        <h3 className="font-display text-xl md:text-[22px] font-semibold text-brand-primary leading-snug tracking-tight group-hover:text-brand-accent transition-colors">
          {title}
        </h3>
        <p className="mt-3 text-sm text-brand-text/80 leading-relaxed line-clamp-3">{excerpt}</p>
        <span className="inline-flex items-center gap-1 mt-auto pt-4 text-sm font-medium text-brand-accent">
          {t('cta.read', { ns: 'common' })}{' '}
          <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
        </span>
      </div>
    </Link>
  );
}
